<template>
  <div class="flex flex-col-reverse md:flex-row gap-2 justify-between items-center py-2">
    <div>
      <b>{{ total }} {{ t("general.records") }}.</b>
      {{ t("general.recordsPerPage") }}
      <VaSelect v-model="localPerPage" class="!w-20" :options="[10, 50, 100]" />
    </div>

    <div v-if="totalPages > 1" class="flex">
      <VaButton
        preset="secondary"
        icon="va-arrow-left"
        aria-label="Previous page"
        :disabled="page === 1"
        @click="$emit('update:page', page - 1)"
      />
      <VaButton
        class="mr-2"
        preset="secondary"
        icon="va-arrow-right"
        aria-label="Next page"
        :disabled="page === totalPages"
        @click="$emit('update:page', page + 1)"
      />
      <VaPagination
        v-model="localPage"
        buttons-preset="secondary"
        :pages="totalPages"
        :visible-pages="7"
        :boundary-links="false"
        :direction-links="false"
        boundary-numbers
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue"
import { useI18n } from "vue-i18n"

const { t } = useI18n()
const props = defineProps({
  page: { type: Number, required: true },
  perPage: { type: Number, required: true },
  total: { type: Number, required: true },
})

const emit = defineEmits(["update:page", "update:perPage"])

const localPage = ref(props.page)
const localPerPage = ref(props.perPage)

watch(
  () => props.page,
  (newVal) => {
    localPage.value = newVal
  },
)
watch(localPage, (newVal) => {
  if (newVal !== props.page) {
    emit("update:page", newVal)
  }
})

watch(localPerPage, (newVal) => {
  if (newVal !== props.perPage) {
    emit("update:perPage", newVal)
  }
})
watch(localPage, (newVal) => {
  if (newVal !== props.page) {
    emit("update:page", newVal)
  }
})

const totalPages = computed(() => Math.ceil(props.total / props.perPage))
</script>
